<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          activator="parent"
          width="auto"
          persistent
          @click:outside="closeModal()"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar flat color="secondary" class="white--text toolbar">
              <v-toolbar-title class="font-weight-bold">{{
                imgData?.group + " - " + imgData?.text
              }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-avatar class="ma-3" v-bind:class="['img-section']" size="auto" min-width="900" rounded="0">
              <v-img :src="imgData.src"></v-img>
            </v-avatar>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    closeModal() {
      this.dialog = false;
    },
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    imgData: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.img-section {
  position: relative;
  top: -72px;
}
.img-section2{
  position: relative;
  top: -32px;
}
.toolbar {
  z-index: 2;
}
</style>